import React, { FC } from 'react';
import { TitleValueProps } from './types';
import { TextWithEllipsis } from '~/components/atoms/text-with-ellipsis';
import { Box, Heading } from '@bechtel/gds';
//Spreading props to pass data-testid
export const TitleValue: FC<TitleValueProps> = ({ title, value, size = '500', ...props }) => {
  return (
    // Min width needs to be set for the textOverflow ellipsis to work for Value
    // lineHeight: normal to avoid font chops(windows > graphikCompact) when overflow:hidden
    <Box alignItems={{ sm: 'center' }} css={{ minWidth: '0', lineHeight: 'normal' }} {...props}>
      <Heading weight="600" color="grey.1000" style={{ flexShrink: 0 }}>
        {title}:&nbsp;
      </Heading>
      <TextWithEllipsis size={size} weight="300" title={value}>
        {value}
      </TextWithEllipsis>
    </Box>
  );
};
